// 던전히어로 커뮤니티 설정(D5b, docs/COMMUNITY-SUPPORT-PRD.md). 서버(src/server/social.ts)와 브라우저(src/community/index.ts)가 같이 쓴다 — 순수 데이터만.
import type { GameConfig } from '../../packages/tll-social/src/shared/protocol';

export const GAME_ID = 'dungeon-hero';

/**
 * - 광장(로비) 채널당 40명(dod D5b "로비 40명"), 5채널 = 동시 200명. 다 차면 hello가 world:null + 'full'.
 * - 명예의 전당·파티 모집은 서버 판정 전투·실시간 파티(D5c) 전까지 탭을 숨긴다 → contents·titleTiers 비움.
 * - 귓속말은 친구끼리만(낯선 사람의 1:1 접근 차단 — 사기·괴롭힘 1차 방어).
 * - 보관 정책: 채팅 본문 30일, 신고는 처리 완료 + 90일(미처리 최대 1년).
 */
export const SOCIAL_CONFIG: GameConfig = {
  gameId: GAME_ID,
  worldChannels: 5,
  worldCapacity: 40,
  contents: [],
  titleTiers: [],
  founders: { maxNo: 1000, titleId: 'founder', label: '창립 모험가' },
  completion: { titleId: 'conqueror', label: '전 지역 정복자' },
  dmFriendsOnly: true,
  chat: { maxLen: 120, minGapMs: 1200, burst: 5, burstWindowMs: 10000, history: 50 },
  // 게임 고유 금칙어(기본 욕설·광고 목록에 더해진다). 이름·채팅·글에 같이 걸리므로 일상어("운영자님 버그요")를 막는 단어는 넣지 않는다
  bannedWords: [],
  retention: { chatDays: 30, reportDays: 90, openReportDays: 365 },
  // 파티 채널은 D5c(레이드 4인 파티 서버)에서 멤버십 검증과 함께 연다 — 그때까지 서버가 party:<코드> 가입을 막는다
  partyChannels: false,
  // 공식·운영 사칭 방지(기본 목록 + 게임 이름)
  reservedNames: ['던전히어로', 'dungeonhero', 'dghero', 'tllhouse'],
};

/** 화면에 보일 탭(파티 모집·명예의 전당은 D5c 전까지 숨김) */
export const COMMUNITY_TABS = ['chat', 'friends', 'board', 'support'] as const;

/**
 * 법정 안내 페이지(정적 HTML, public/{terms,refund,odds,privacy,support,account-delete}.html — 운영 주소는 확장자 없는 /terms · /refund · /odds · /privacy · /support · /account-delete).
 * 설정 창·고객센터·처음 Google 연결 화면·타이틀·젬 상점이 같은 목록을 쓴다. 새 탭으로 열어 게임 진행을 끊지 않는다.
 * KG이니시스 상점ID 심사용 공개 페이지(2026-10-29): 이용약관·청약철회/환불·확률 정보·개인정보처리방침·고객센터.
 */
export const LEGAL_LINKS: readonly { label: string; href: string }[] = [
  { label: '이용약관', href: '/terms' },
  { label: '청약철회·환불', href: '/refund' },
  { label: '확률 정보', href: '/odds' },
  { label: '개인정보처리방침', href: '/privacy' },
  { label: '고객센터', href: '/support' },
  { label: '계정 삭제 안내', href: '/account-delete' },
];

/** 법정 안내 페이지 시행일(표기용). 페이지 본문·푸터와 같은 날짜여야 한다(legalPages.test.ts) */
export const LEGAL_EFFECTIVE = '2026년 10월 29일';

/** 사업자 정보(정본 = Drive "사업자 정보 — 더 럭셔리 로드", 2026-10-29). 모든 법정 페이지 푸터와 젬 상점 하단이 같은 값을 쓴다 */
export const BUSINESS_INFO = {
  name: '더 럭셔리 로드 (The Luxury Lord)',
  representative: '양경렬',
  registrationNo: '849-09-03410',
  mailOrderNo: '제2026-충남서산-0101호',
  address: '충청남도 서산시 석남1로 33-8 (석남동)',
  email: 'aljjang95@gmail.com',
  phone: '010-8804-8903',
  gameMakerNo: '제 2026-000002 호 (서산시)',
} as const;
